import { Box } from '@mui/material';
import { Header } from 'components/home';
import { TopNavBar } from 'components/top_nav_bar';
import { MenuProvider } from 'contexts/menu/menu_context';
import React, { useEffect, useState } from 'react';
import useCifaStore from 'stores/cifa/cifa.store';
import { ROUTES } from 'routes/constants';
import { useNavigate, useLocation } from 'react-router-dom';
import ViewFinancialResource from './ViewFinancialResource';

export interface FinancialResourceForm {
    tipo: 'Programa' | 'Projeto' | 'Ação/Atividade';
    descricao: string;
    valor_orcado: number;
    valor_liquidado: number;
}

interface StepData {
    recursos: FinancialResourceForm[];
    rcl: number;
}

const parseSafeNumber = (value: string | number | null | undefined): number => {
    if (value === null || value === undefined) return 0;
    if (typeof value === 'number') return value;
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
};

const ViewFinancialResourcePage: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { cifa } = useCifaStore();

    // Extrai o ano da rota, ex: /service_management/cifa-2027 => 2027
    const match = /cifa-(\d{4})/.exec(location.pathname);
    const anoReferencia = match ? Number(match[1]) : 2026;

    const [localData, setLocalData] = useState<StepData>({
        recursos: [],
        rcl: 0
    });

    useEffect(() => {
        if (!cifa.uuid) {
            navigate(ROUTES[`CIFA${anoReferencia}` as keyof typeof ROUTES] as string);
            return;
        }

        setLocalData({
            recursos: cifa.recursos_financeiros_aplicados_detalhamento || [],
            rcl: parseSafeNumber(cifa.receita_corrente_liquida_2025)
        });
    }, [cifa, navigate, anoReferencia, location.pathname]);

    return (
        <MenuProvider>
            <TopNavBar />
            <Header title={`CIFA - Visualização dos Recursos Financeiros - ${anoReferencia}`} showBackButton={true} />
            <Box width='97%' display='flex' flexDirection='column' justifyContent='center' alignItems='center' margin='2rem'>
                <ViewFinancialResource recursos={localData.recursos} rcl={localData.rcl} />
            </Box>
        </MenuProvider>
    );
};

export default ViewFinancialResourcePage;
